/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ModifyLoanPage = lazyLoad(
  () => import('./index'),
  module => module.ModifyLoanPage,
);
